import { getWordPressProps, WordPressTemplate } from '@faustwp/core';
import { fetchFrontPageSharedData } from '../lib/fetch-front-page-shared-data';
import { getHomepageDatabaseIds } from '../lib/polylang';

export default function Page(props) {
  return <WordPressTemplate {...props} />;
}

export async function getStaticProps(ctx) {
  const wordpressProps = await getWordPressProps({ ctx });

  let additionalData = {};

  try {
    const { getApolloClient } = await import('@faustwp/core');
    const apolloClient = getApolloClient();
    const { no: homepageId } = getHomepageDatabaseIds();
    additionalData = await fetchFrontPageSharedData(apolloClient, homepageId);
  } catch (error) {
    console.error('Error fetching additional frontpage data:', error);
  }

  return {
    ...wordpressProps,
    props: {
      ...wordpressProps.props,
      ...additionalData,
    },
    revalidate: process.env.NODE_ENV === 'production' ? 60 * 5 : 10,
  };
}
